import { useFormContext } from 'react-hook-form'

import { FormError } from '@fortem-monorepo/react-ui'
import { SearchSelect } from '@fortem-monorepo/react-ui'
import { FormField, FormItem, FormLabel } from '@fortem-monorepo/react-ui'

import {
  GuidelineFormValues,
  IcGuidelineTables,
} from '@/pages/funds/ic-guidelines-v2/components/edit-guideline-form/schema'

export interface TableFieldProps {}

export const TableField: React.FC<TableFieldProps> = ({}) => {
  const { control, setValue } = useFormContext<GuidelineFormValues>()

  return (
    <FormField
      name="table"
      control={control}
      render={({ field: { value } }) => {
        return (
          <FormItem>
            <div className="flex items-center gap-2 overflow-hidden">
              <FormLabel>Target Table</FormLabel>
              <FormError />
            </div>
            <SearchSelect
              value={value}
              placeholder={'Select a target table...'}
              setValue={(val) =>
                setValue('table', val as (typeof IcGuidelineTables)[number], {
                  shouldValidate: true,
                  shouldDirty: true,
                })
              }
              options={IcGuidelineTables.map((t) => ({ label: t, value: t }))}
            />
          </FormItem>
        )
      }}
    />
  )
}
